// Discord integration preferences. Persisted via the shared
// preferences store (file-backed in the OS app-data dir).

import { getPref, setPref } from '../persistentPrefs';

const STORAGE_KEY = 'fab-arena-discord-settings';

const defaults = {
  showActivity: true,       // Send Rich Presence to Discord at all
  allowSpectators: true,    // Default for new game sessions. Show Join button
};

let cached = null;

export function getDiscordSettings() {
  if (cached) return cached;
  const stored = getPref(STORAGE_KEY, null);
  cached = stored && typeof stored === 'object' ? { ...defaults, ...stored } : { ...defaults };
  return cached;
}

export function saveDiscordSettings(settings) {
  cached = { ...(cached || defaults), ...settings };
  setPref(STORAGE_KEY, cached);
}
